(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gaffit-product-tabs')) {
    customElements.define(
      'gaffit-product-tabs',
      class GaffitProductTabs extends HTMLElement {
        connectedCallback() {
          this.buttons = Array.from(this.querySelectorAll('[data-product-tab-button]'));
          this.panels = Array.from(this.querySelectorAll('[data-product-tab-panel]'));

          this.buttons.forEach((button) => {
            button.addEventListener('click', () => this.activate(button.dataset.productTabButton));
          });
        }

        activate(tabName) {
          this.buttons.forEach((button) => {
            const isActive = button.dataset.productTabButton === tabName;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-selected', isActive ? 'true' : 'false');
            button.tabIndex = isActive ? 0 : -1;
          });

          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.productTabPanel !== tabName;
          });

          window.requestAnimationFrame(() => {
            window.dispatchEvent(new Event('resize'));
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["venox-featured-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;

      if (number == null || isNaN(number)) return '0';

      var fixed = (Number(number) / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    function formatMoney(cents, format) {
      var amount = Number(cents || 0);
      var moneyFormat = format || '₹{{amount}}';
      var placeholderMatch = moneyFormat.match(/\{\{\s*(amount(?:_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator|_with_apostrophe_separator)?)\s*\}\}/);
      var placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';
      var value;

      switch (placeholder) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(amount, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(amount, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(amount, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(amount, 2, "'", '.');
          break;
        default:
          value = formatWithDelimiters(amount, 2, ',', '.');
      }

      var tokenPattern = new RegExp('\\{\\{\\s*' + placeholder + '\\s*\\}\\}');
      var html = moneyFormat.replace(tokenPattern, value);
      var temp = document.createElement('div');
      temp.innerHTML = html;
      return (temp.textContent || temp.innerText || '').trim();
    }

    var ROOT_SELECTOR = '[data-venox-featured-buy]';

    function toArray(nodeList) {
      return Array.prototype.slice.call(nodeList || []);
    }

    function parseInteger(value, fallback) {
      var number = parseInt(value, 10);
      return Number.isFinite(number) ? number : fallback;
    }

    function getSelectedOption(select) {
      if (!select || select.selectedIndex < 0) return null;
      return select.options[select.selectedIndex] || null;
    }

    function setGallery(section, index) {
      var normalizedIndex = String(index);
      var thumbs = toArray(section.querySelectorAll('[data-venox-thumb]'));
      var panels = toArray(section.querySelectorAll('[data-venox-panel]'));

      thumbs.forEach(function (thumb) {
        var active = thumb.getAttribute('data-venox-thumb') === normalizedIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        thumb.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-venox-panel') === normalizedIndex;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    function setGalleryByMediaId(section, mediaId) {
      if (!mediaId) return;

      var thumb = section.querySelector('[data-venox-thumb][data-media-id="' + String(mediaId) + '"]');
      if (thumb) setGallery(section, thumb.getAttribute('data-venox-thumb'));
    }

    function getStockWidth(available, inventory) {
      if (!available) return 0;
      if (inventory <= 0) return 82;
      return Math.min(Math.max(inventory * 12, 18), 90);
    }

    function updateVariant(section, updateHistory) {
      var select = section.querySelector('[data-venox-variant-select]');
      var selected = getSelectedOption(select);
      if (!selected) return;

      var price = section.querySelector('[data-venox-price]');
      var compare = section.querySelector('[data-venox-compare]');
      var availability = section.querySelector('[data-venox-availability]');
      var stockFill = section.querySelector('[data-venox-stock-fill]');
      var submit = section.querySelector('[data-venox-submit]');
      var formStatus = section.querySelector('[data-venox-form-status]');

      var inventory = parseInteger(selected.getAttribute('data-inventory'), 0);
      var available = selected.getAttribute('data-available') === 'true';
      var moneyFormat = section.getAttribute('data-money-format') || '₹{{amount}}';
      var priceCents = parseInt(selected.getAttribute('data-price-cents'), 10) || 0;
      var compareCents = parseInt(selected.getAttribute('data-compare-cents'), 10) || 0;
      var variantUrl = selected.getAttribute('data-url') || '';
      var mediaId = selected.getAttribute('data-media-id') || '';

      if (price) price.textContent = formatMoney(priceCents, moneyFormat);

      if (compare) {
        var hasCompare = compareCents > priceCents;
        compare.textContent = hasCompare ? formatMoney(compareCents, moneyFormat) : '';
        compare.classList.toggle('is-hidden', !hasCompare);
      }

      if (availability) {
        if (!available) {
          availability.textContent = 'Currently unavailable.';
        } else if (inventory > 0 && inventory <= 5) {
          availability.textContent = 'Hurry, limited stock available! Only ' + inventory + ' left in stock.';
        } else {
          availability.textContent = 'In stock and ready to ship.';
        }
      }

      if (stockFill) {
        stockFill.style.setProperty('--venox-stock', getStockWidth(available, inventory) + '%');
      }

      if (submit) {
        submit.disabled = !available;
        submit.setAttribute('aria-disabled', available ? 'false' : 'true');
      }

      if (formStatus) formStatus.textContent = '';
      setGalleryByMediaId(section, mediaId);

      if (updateHistory && variantUrl && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', variantUrl);
      }

      section.dispatchEvent(new CustomEvent('venox:variant:change', {
        bubbles: true,
        detail: {
          id: selected.value,
          available: available,
          inventory: inventory
        }
      }));
    }

    function sanitizeQuantity(input) {
      if (!input) return 1;
      var min = parseInteger(input.getAttribute('min'), 1);
      var maxValue = input.getAttribute('max');
      var max = maxValue ? parseInteger(maxValue, null) : null;
      var value = parseInteger(input.value, min);

      value = Math.max(value, min);
      if (max !== null) value = Math.min(value, max);

      input.value = String(value);
      return value;
    }

    function refreshCart(item) {
      var detail = { item: item };
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: detail }));
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true, detail: detail }));
      window.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
    }

    function handleSubmit(section, form) {
      var submit = form.querySelector('[data-venox-submit]');
      var status = section.querySelector('[data-venox-form-status]');
      var select = section.querySelector('[data-venox-variant-select]');
      var selected = getSelectedOption(select);

      if (!submit || submit.disabled) return;
      if (selected && selected.getAttribute('data-available') !== 'true') return;

      var originalText = submit.textContent.trim();
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.textContent = 'Adding...';
      if (status) status.textContent = '';

      var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              throw new Error(data.description || data.message || 'Unable to add this item to cart.');
            }
            return data;
          });
        })
        .then(function (item) {
          submit.textContent = 'Added!';
          if (status) status.textContent = 'Product added. Redirecting to cart...';
          refreshCart(item);

          var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
            ? window.Shopify.routes.root + 'cart'
            : '/cart';

          window.location.assign(cartUrl);
        })
        .catch(function (error) {
          submit.textContent = 'Try again';
          if (status) status.textContent = error && error.message ? error.message : 'Unable to add this item to cart.';

          window.setTimeout(function () {
            submit.textContent = originalText;
            submit.removeAttribute('aria-busy');
            updateVariant(section, false);
          }, 1800);
        });
    }

    function onSectionClick(section, event) {
      var thumb = event.target.closest('[data-venox-thumb]');
      if (thumb && section.contains(thumb)) {
        setGallery(section, thumb.getAttribute('data-venox-thumb'));
        return;
      }

      var input = section.querySelector('.venox-featured-buy__qty-input');
      if (!input) return;

      if (event.target.closest('[data-venox-qty-minus]')) {
        input.value = String(Math.max(sanitizeQuantity(input) - 1, parseInteger(input.min, 1)));
      }

      if (event.target.closest('[data-venox-qty-plus]')) {
        input.value = String(sanitizeQuantity(input) + 1);
        sanitizeQuantity(input);
      }
    }

    function initSection(section) {
      if (!section || section.__venoxInitialized) return;
      section.__venoxInitialized = true;

      section.addEventListener('click', function (event) {
        onSectionClick(section, event);
      });

      section.addEventListener('change', function (event) {
        if (event.target.matches('[data-venox-variant-select]')) {
          updateVariant(section, true);
        }

        if (event.target.matches('.venox-featured-buy__qty-input')) {
          sanitizeQuantity(event.target);
        }
      });

      section.addEventListener('keydown', function (event) {
        var thumb = event.target.closest('[data-venox-thumb]');
        if (!thumb || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;

        var thumbs = toArray(section.querySelectorAll('[data-venox-thumb]'));
        var currentIndex = thumbs.indexOf(thumb);
        var nextIndex = event.key === 'ArrowRight' ? currentIndex + 1 : currentIndex - 1;

        if (nextIndex < 0) nextIndex = thumbs.length - 1;
        if (nextIndex >= thumbs.length) nextIndex = 0;

        event.preventDefault();
        thumbs[nextIndex].focus();
        setGallery(section, thumbs[nextIndex].getAttribute('data-venox-thumb'));
      });

      var form = section.querySelector('[data-venox-form]');
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          sanitizeQuantity(form.querySelector('.venox-featured-buy__qty-input'));
          handleSubmit(section, form);
        });
      }

      setGallery(section, 0);
      updateVariant(section, false);
    }

    function initAll(container) {
      toArray((container || document).querySelectorAll(ROOT_SELECTOR)).forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      }, { once: true });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.matches && event.target.matches(ROOT_SELECTOR)) {
        initSection(event.target);
      } else {
        initAll(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
